import { Component, OnInit } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';

import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { DataService, HelperService, HTTPService, ValidationService } from 'app/services';
import { campaignTypes, followUpEventList, followUpEventTags } from 'app/constants/marketing.constants';

import { difference, find, intersection } from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mkt-email-template-dialog',
  templateUrl: './mkt-email-template-dialog.component.html',
  styleUrls: ['./mkt-email-template-dialog.component.scss'],
  providers: [DialogService],
})
export class MktEmailTemplate implements OnInit {
  campaignTemplateId: string = '';
  campaignTemplateText: string = '';
  campaignTemplateTextFR: string = '';
  template = {
    name: '',
    subject: '',
    subjectFR: '',
    text: '',
    textFR: '',
    email: '',
    campaignType: '',
    followUpEvent: null,
  };
  errors: any = {};

  embeddings = {
    CUSTOMER_FIRST_NAME: '[[CUSTOMER_FIRST_NAME]]',
    CUSTOMER_LAST_NAME: '[[CUSTOMER_LAST_NAME]]',
    SHOP_NAME: '[[SHOP_NAME]]',
    SHOP_CONTACT_NUMBER: '[[SHOP_CONTACT_NUMBER]]',
    APPT_REQUEST: '[[APPOINTMENT_REQ_LINK]]',
  };

  isLoading: boolean = false;
  isProcessing: boolean = false;
  isSending: boolean = false;
  companyNameLength: number = 0;
  tooltipText: string = '';
  isOpenedFromCampaign: boolean = false;
  isOpenedFromScheduledFollowups: boolean = false;
  isUpdateMasterTemplate: boolean = false;
  compaignFollowUpEvent: string = '';
  campaignTypes = campaignTypes;
  followUpEvents = followUpEventList;
  eventTags: any[] = [];
  isReadOnly: boolean = false;
  isShowApptRequestTag: boolean;
  previewLink: string = '';
  companyLocalization: boolean = false;
  currentLang: string = 'en';
  companyLocalizationSubscription: Subscription;
  textAreaFocusEN: boolean = false;
  textAreaFocusFR: boolean = false;
  isSMSCampaignLimitEnabled: boolean = false;
  urlRegex = "([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?";

  constructor(
    private httpService: HTTPService,
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    public helperService: HelperService,
    private dataService: DataService,
    private validationService: ValidationService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    const { companyName = '' } = this.helperService.getCompany();
    const { isOpenedFromCampaign, campaignTemplateText, campaignTemplateTextFR, campaignType, campaignTemplateId, followUpEvent, isReadOnly, isOpenedFromScheduledFollowups } = this.dialogConfig.data;

    if (this.dataService.isApptRequestPortalEnabled && this.dataService.isMarketingEnabled && this.dataService.isMarketingLeadAttributionEnabled) {
      this.isShowApptRequestTag = true;
    }
    this.getAppointmentReqLink();
    this.isReadOnly = isReadOnly;
    this.compaignFollowUpEvent = followUpEvent;
    this.campaignTemplateText = campaignTemplateText;
    this.companyNameLength = companyName.length;
    this.template.campaignType = campaignType;
    this.isOpenedFromCampaign = isOpenedFromCampaign;
    this.isOpenedFromScheduledFollowups = isOpenedFromScheduledFollowups;
    this.getLocalizationFlags();
    if (this.campaignTemplateText) {
      this.template.text = campaignTemplateText;
    } if (this.campaignTemplateTextFR) {
      this.template.textFR = campaignTemplateTextFR;
    }
    this.isSMSCampaignLimitEnabled = this.dataService.isSMSCampaignLimitEnabled;

    if (campaignTemplateId) {
      this.campaignTemplateId = campaignTemplateId;
      this.getCampaignTemplate(campaignTemplateText, campaignTemplateTextFR);
    }
  }


  getLocalizationFlags() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    this.companyLocalizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      if (value) {
        this.companyLocalization = value
        if (!isMultiLocationEnabled) {
          this.httpService.getCompanyPreferredLanguage().then((res: any) => {
            const lang = res.preferredLanguage
            if (lang) {
              this.currentLang = lang.toLowerCase();
            }
          });
        } else {
          this.httpService.getCompanyDetails(this.helperService.getCompany().companyId).then((company: any) => {
            const lang = company.shop.preferredLanguage;
            if (lang) this.currentLang = lang.toLowerCase();
          })
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.companyLocalizationSubscription) {
      this.companyLocalizationSubscription.unsubscribe();
    }
  }

  onFocusEN() {
    this.textAreaFocusEN = true;
    this.textAreaFocusFR = false;
  }

  onFocusFR() {
    this.textAreaFocusEN = false;
    this.textAreaFocusFR = true;
  }

  onBlur(key: string){
    if(this.isSMSCampaignLimitEnabled){
      if(key === 'text' && new RegExp(this.urlRegex).test(this.template.text)){
        this.errors.text = 'You are using a custom link in your message: custom URLs run the risk of damaging phone reputation so you are encouraged to use the links available to you'
      }

      if(key === 'textFR' && new RegExp(this.urlRegex).test(this.template.textFR)){
        this.errors.textFR = 'You are using a custom link in your message: custom URLs run the risk of damaging phone reputation so you are encouraged to use the links available to you'
      }
    }
  }

  async getAppointmentReqLink() {
    const companyId = this.helperService.getCompany().companyId;
    let response = await this.httpService.getAppointmentRequestSetting(companyId);
    this.previewLink = response.apptRequestLink;
  }

  getCampaignTemplate(campaignTemplateText, campaignTemplateTextFR): void {
    this.httpService.getSingleMarketingTemplates(this.campaignTemplateId).then((template: any) => {
      if (!template) return;

      this.template = {
        ...this.template,
        name: template.name,
        text: campaignTemplateText || template.text,
        subject: template.subject,
        subjectFR: template.subjectFR,
        textFR: campaignTemplateTextFR || template.textFR,
        campaignType: template.campaignType,
      };

      if (template.campaignType === this.campaignTypes.FOLLOWUP && template.followUpEvent) {
        const campaignTags = followUpEventTags[this.compaignFollowUpEvent || template.followUpEvent] || [];
        const templateTags = followUpEventTags[template.followUpEvent] || [];

        const validTags = intersection(
          templateTags.map(({ value }) => value),
          campaignTags.map(({ value }) => value)
        );
        this.eventTags = templateTags.filter(({ value }) => validTags.includes(value));
        this.template.followUpEvent = find(this.followUpEvents, { value: template.followUpEvent });
      }

      if (this.campaignTemplateText) {
        this.template.text = this.campaignTemplateText;
      }
    });
  }

  handleChange(key: string, value: any, { isForcedUpdate = false } = {}): void {
    this.errors[key] = '';

    // Setting and updating tags
    if (key === 'followUpEvent') {
      let isConfirmationNeeded = false;
      const tags = followUpEventTags[value.value] || [];
      const tagsToRemoved = difference(
        [...this.eventTags].map(({ value }) => value),
        tags.map(({ value }) => value)
      );

      for (let i = 0; i < tagsToRemoved.length; i++) {
        if (this.template.text && this.template.text.includes(tagsToRemoved[i])) {
          isConfirmationNeeded = true;
          break;
        }
      }

      if (isConfirmationNeeded && !isForcedUpdate) {
        this.showEventChangeConfirmation(key, value);
        return;
      }

      this.removeInvalidTag([...this.eventTags], tags);
      this.eventTags = tags;
    }

    this.template[key] = value;
    if (key === 'text') {
      let textArea: any = document.getElementById('Vtemplate-text');
      textArea.value = value;
    }
  }

  showEventChangeConfirmation(key: string, value: any) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: 'Update event?',
        message: 'Some tags might get lost in case you update the event ',
        button: {
          success: { title: 'Update' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.handleChange(key, value, { isForcedUpdate: true });
      }

      onClose.unsubscribe();
    });
  }

  insertEmbedding(embedding: any) {
    if (this.isReadOnly) return;

    const txtarea: any = document.getElementById('Vtemplate-text');
    const txtareaFR: any = document.getElementById('Vtemplate-text-fr');

    let focusedTextarea: any;
    if (this.textAreaFocusFR) {
      focusedTextarea = txtareaFR;
    } else if (this.textAreaFocusEN) {
      focusedTextarea = txtarea;
    } else {
      return;
    }

    if (!focusedTextarea) return;

    const doc = document as any;

    const scrollPos = focusedTextarea.scrollTop;
    let strPos = 0;
    const br = focusedTextarea.selectionStart || focusedTextarea.selectionStart === '0' ? 'ff' : doc.selection ? 'ie' : false;

    if (br == 'ie') {
      focusedTextarea.focus();
      const range = doc.selection.createRange();
      range.moveStart('character', -focusedTextarea.value.length);
      strPos = range.text.length;
    } else if (br == 'ff') {
      strPos = focusedTextarea.selectionStart;
    }

    const front = focusedTextarea.value.substring(0, strPos);
    const back = focusedTextarea.value.substring(strPos, focusedTextarea.value.length);
    focusedTextarea.value = front + embedding + back;
    strPos = strPos + embedding.length;

    if (br == 'ie') {
      focusedTextarea.focus();
      let ieRange = doc.selection.createRange();
      ieRange.moveStart('character', -focusedTextarea.value.length);
      ieRange.moveStart('character', strPos);
      ieRange.moveEnd('character', 0);
      ieRange.select();
    } else if (br == 'ff') {
      focusedTextarea.selectionStart = strPos;
      focusedTextarea.selectionEnd = strPos;
      focusedTextarea.focus();
    }

    focusedTextarea.scrollTop = scrollPos;

    if (focusedTextarea === txtarea) {
      this.template.text = txtarea.value;
    } else if (focusedTextarea === txtareaFR) {
      this.template.textFR = txtareaFR.value;
    }
  }

  private validate(checkEmail: boolean = false): boolean {
    let isValid: boolean = true;

    this.errors = {};

    if (this.template.subjectFR && !this.template.textFR) {
      this.errors.textFR = 'French template text is required if French subject is provided';
      isValid = false;
    }

    if (this.template.textFR && !this.template.subjectFR) {
      this.errors.subjectFR = 'French subject is required if French template text is provided';
      isValid = false;
    }

    if(this.isSMSCampaignLimitEnabled){
      if(new RegExp(this.urlRegex).test(this.template.text)){
        this.errors.text = 'You are using a custom link in your message: custom URLs run the risk of damaging phone reputation so you are encouraged to use the links available to you'
        isValid = false;
      }

      if(new RegExp(this.urlRegex).test(this.template.textFR)){
        this.errors.textFR = 'You are using a custom link in your message: custom URLs run the risk of damaging phone reputation so you are encouraged to use the links available to you'
        isValid = false;
      }
    }

    if (!this.template.name) {
      this.errors.name = 'Template name is required';
      isValid = false;
    }

    if (!this.template.text) {
      this.errors.text = 'Template text is required';
      isValid = false;
    }

    if (!this.template.subject) {
      this.errors.subject = 'Template subject is required';
      isValid = false;
    }

    if (this.template.campaignType === this.campaignTypes.FOLLOWUP && !this.template.followUpEvent) {
      this.errors.followUpEvent = 'Follow-up event is required';
      isValid = false;
    }

    if (checkEmail && this.template.email && !this.validationService.validateEmail(this.template.email)) {
      this.errors.email = 'Email is not valid';
      isValid = false;
    }

    return isValid;
  }

  parseTemplate(template: any) {
    const { userName = '', companyPhone, companyName } = this.helperService.getCompany();
    const [firstName, ...lastNames] = userName.split(' ');
    const lastName = lastNames.join(' ');

    ['subject', 'text', 'textFR'].forEach((key) => {
      if (template[key]) {
        template[key] = template[key].replace(new RegExp('\\[\\[CUSTOMER_FIRST_NAME\\]\\]', 'g'), firstName);
        template[key] = template[key].replace(new RegExp('\\[\\[CUSTOMER_LAST_NAME\\]\\]', 'g'), lastName);
        // template[key] = template[key].replace(new RegExp('\\[\\[SHOP_NAME\\]\\]', 'g'), companyName);
        // template[key] = template[key].replace(new RegExp('\\[\\[SHOP_CONTACT_NUMBER\\]\\]', 'g'), companyPhone);
        // template[key] = template[key].replace(new RegExp('\\[\\[SHOP_CONTACT_NUMBER\\]\\]', 'g'), companyPhone);
        // template[key] = template[key].replace(new RegExp('\\[\\[APPOINTMENT_REQ_LINK\\]\\]', 'g'), this.previewLink);
      }
    });

    return template;
  }

  sendPreviewEmail(): void {
    if (!this.validate(true) || this.isSending) return;

    const template = this.parseTemplate({ ...this.template });

    this.isSending = true;
    this.httpService
      .sendPreviewEmail({
        email: this.template.email,
        template,
      })
      .then(() => {
        this.helperService.showToaster('success', 'Sent successfully');
      })
      .catch((err) => this.helperService.showToaster('error', err))
      .finally(() => {
        this.isSending = false;
      });
  }

  /** Close dialog */
  closeDialog(isSuccess: boolean = false, data: any = {}) {
    if (!data.text) {
      let textArea: any = document.getElementById('Vtemplate-text');
      this.template.text = this.campaignTemplateText;
      textArea.value = this.template.text;
    }
    this.dialogRef.close({ isSuccess, data });
  }

  removeInvalidTag(oldTags: any[], newTags: any[]) {
    const tags = difference(
      oldTags.map(({ value }) => value),
      newTags.map(({ value }) => value)
    );

    tags.forEach((tag: string) => {
      this.template.subject = this.template.subject.replace(new RegExp(this.helperService.escapeRegex(`${tag}`), 'g'), '');
      this.template.text = this.template.text.replace(new RegExp(this.helperService.escapeRegex(`${tag}`), 'g'), '');
    });
  }

  async onSave() {
    if (!this.validate() || this.isProcessing || this.isLoading || this.isSending || this.isReadOnly) return;
    this.isProcessing = true;
    this.isLoading = true;
    if (this.isOpenedFromScheduledFollowups) {
      this.closeDialog(true, { text: this.template.text });
      return;
    }

    const data = {
      name: this.template.name,
      text: this.template.text,
      subject: this.template.subject,
      subjectFR: this.template.subjectFR,
      textFR: this.template.textFR,
      templateType: 'EMAIL',
      campaignType: this.template.campaignType,
      followUpEvent: null,
    };

    if (this.template.campaignType === this.campaignTypes.FOLLOWUP && this.template.followUpEvent) {
      data.followUpEvent = this.template.followUpEvent.value;
    }

    // Don't make the update call if user want's to update the template locally
    if (this.isOpenedFromCampaign && !this.isUpdateMasterTemplate) {
      this.closeDialog(true, { ...data });
      return;
    }

    try {
      let template = {};

      if (!this.campaignTemplateId) {
        template = await this.httpService.createMarketingTemplates(data);
        this.helperService.showToaster('success', 'Email Template successfully created');
      } else {
        template = await this.httpService.updateMarketingTemplates(this.campaignTemplateId, data);
        this.helperService.showToaster('success', 'Email Template successfully updated');
      }
      this.dataService.sendData(this.dataService.typePassData('campaign-template-list', {}));

      this.closeDialog(true, template);
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isProcessing = false;
      this.isLoading = false;
    }
  }
}
